/* global window */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class _PaymentProcessingInFramePage extends Component {
  componentDidMount() {
    window.parent.postMessage('payment:check-status', window.location.href);
  }

  render() {
    return (
      <h3 className="u-text-center centerer">Verifying Payment, Please Wait</h3>
    );
  }
}

export default withRouter(_PaymentProcessingInFramePage);



// WEBPACK FOOTER //
// ./src/pages/PaymentProcessingInFramePage.js